/**
 * Endpoint wrappers — Phase 6a.4 per spec §7.3.
 *
 * Thin typed bindings around apiFetch. Components do NOT call these
 * directly — Service Layer (Phase 6a.5) wraps them with retry / cold-start
 * handling / error transformation.
 *
 * Phase 6a.8b: added `engagementCalculate` for the engagement layer per
 * Backend Spec §20.4.
 */

import type {
  CalculateEngagementRequest,
  CalculateEngagementSuccessResponse,
  CalculateRequest,
  CalculateSuccessResponse,
} from "@/types";

import { apiFetch } from "./client";

export const endpoints = {
  health: () =>
    apiFetch<{ status: string; version: string; mode: string }>("/api/health"),

  calculate: (input: CalculateRequest) =>
    apiFetch<CalculateSuccessResponse>("/api/calculate", {
      method: "POST",
      body: JSON.stringify(input),
    }),

  engagementCalculate: (
    input: CalculateEngagementRequest,
    options?: { signal?: AbortSignal },
  ) =>
    apiFetch<CalculateEngagementSuccessResponse>(
      "/api/engagements/calculate",
      {
        method: "POST",
        body: JSON.stringify(input),
      },
      options,
    ),
};
